<div class="thumb-container" dpadSelectable [class.dpad-zone-start]="dstart" [class.dpad-start]="dstart" (keydown)="handleKeyDown($event)" (keyup)="handleKeyUp($event)" (focus)="focused.emit()" [scrollTo]="true" [class.show-options]="showOptions"  #thumb>
    <img *ngIf="newVideo" class="thumb-new" src="{{config.remoteConfig.new_badge}}" alt="New Video" />
    <div class="thumb-image-container">

        <a class="thumb-image">
            <a class="thumb-link" [routerLink]="['/video', media.mediaId]">
                <picture>
                    <source *ngIf="this.media && this.media.image" srcset="{{this.media.image + '?width=250'}}">
                    <img class="thumb-image h-100 w-100" src="{{config.remoteConfig.loading_packshot}}"
                         alt="Loading Image"/>
                </picture>
                <div class="media-duration">
                    <div *ngIf="media.duration" [ngClass]="{ 'media-padding': progress > 0 }">
                        {{media.duration}}
                    </div>
                </div>
            </a>
        </a>

        <a class="thumb-hover-image" [routerLink]="['/video', media.mediaId]" [queryParams]="{recommendationId: recommendationId}">
            <picture>
                <source *ngIf="this.media && this.media.previewImage" srcset="{{this.media.previewImage}}"
                        type="image/webp">
                <source *ngIf="this.media && this.media.image" srcset="{{this.media.image + '?width=250'}}">
                <img class="thumb-image h-100 w-100" src="{{config.remoteConfig.loading_packshot}}"
                     alt="{{media.title}} Image"/>
            </picture>
        </a>

    </div>

    <app-progress-bar [barHeight]="6" [progress]="progress" [max]="100"
                      [class.d-none]="!progress"></app-progress-bar>

    <div class="thumb-lower-container" [class.show-options]="showOptions" [class.no-badge-padding]="!showBadges">
        <div class="channel-badge" *ngIf="media.channelBadgeUrl && showBadges">
          <img
               src="{{media.channelBadgeUrl}}" alt="Channel Badge"/>
        </div>

        <div class="thumb-text-container">
            <div class="thumb-text">
                {{media.title}}
            </div>
            <div class="additional-info">
                <div *ngIf="showBadges">{{media.creator}}<br></div>
                {{timeAgo}}
            </div>
        </div>
    </div>
    <div class="thumb-options" *ngIf="showOptions && !media.seasonId && !media.livestreamId" dpadContainerBasic>
        <div class="option-button">
          <button (click)="redirectToVideo()"
                  #playButton
                  dpadSelectable
                  (focus)="focusedElement = 'play'">
            <span class="button-text">Play Video</span>
            <span class="icon-circle">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <polygon points="7,5 7,15 15,10" fill="currentColor"/>
              </svg>
            </span>
          </button>
        </div>
        <div class="option-button">
            <button *ngIf="!existsInPlaylist(media.id) && !addToPlaylistLoading"
                    #watchlistButton
                    dpadSelectable
                    (focus)="focusedElement = 'watchlist'"
                    (click)="addToPlaylist(media.id)">
              <span class="button-text">Add To Watchlist</span>
              <span class="icon-circle">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <line x1="10" y1="5" x2="10" y2="15" stroke="currentColor" stroke-width="2"/>
                  <line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
                </svg>
              </span>
            </button>

            <button *ngIf="existsInPlaylist(media.id) && !addToPlaylistLoading"
                    #watchlistButton
                    dpadSelectable
                    (focus)="focusedElement = 'watchlist'"
                    (click)="deleteFromPlaylist(media.id)">
              <span class="button-text">Remove From Watchlist</span>
              <span class="icon-circle">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
                </svg>
              </span>
            </button>

            <button *ngIf="addToPlaylistLoading"
                    #watchlistButton
                    dpadSelectable
                    (focus)="focusedElement = 'watchlist'">
              <span class="button-text">Loading</span>
              <span class="icon-circle-loading icon-circle">
                  <svg xmlns="http://www.w3.org/2000/svg" height="12px" viewBox="0 -960 960 960" width="12px" fill="black"><path d="M480-516q65 0 110.5-45.5T636-672v-120H324v120q0 65 45.5 110.5T480-516ZM192-96v-72h60v-120q0-59 28-109.5t78-82.5q-49-32-77.5-82.5T252-672v-120h-60v-72h576v72h-60v120q0 59-28.5 109.5T602-480q50 32 78 82.5T708-288v120h60v72H192Z"/></svg>
              </span>
            </button>
        </div>
    </div>
</div>
